module.exports = __webpack_public_path__ + "static/media/10_perspectives-burnaby.9f3fc893.jpg";